import React, { useMemo } from "react";

import {
  Configuration,
  LoginControllerApi,
} from "@dopingtech/teacher_plus_bff_api_ts";

import { ApiContext } from "./api.context";
import { ApiContextProps, ApiProviderProps } from "./Api.model";
import { useAuthStore } from "@/zustand/auth/store";

export const ApiProvider: React.FC<ApiProviderProps> = ({ children }) => {
  const { data: authData } = useAuthStore();

  const api = useMemo<ApiContextProps>(() => {
    const config = new Configuration({
      accessToken: authData?.accessToken ?? "",
      basePath: process.env.API_URL!.replace(/\/+$/, ""),
    });

    return {
      LoginControllerApi: new LoginControllerApi(config),
    };
  }, [authData?.accessToken]);

  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
};
